import { createAsyncThunk } from '@reduxjs/toolkit';
import { 
  CreateResourceRequest, 
  UpdateResourceRequest,
  DeleteResourceRequest,
  CreateResourceResponse,
  UpdateResourceResponse,
  DeleteResourceResponse
} from '../../models/Resources.model';
import { environment } from '../../environments';

const API_BASE_URL = environment.apiUrl;

export const createResource = createAsyncThunk<
  CreateResourceResponse,
  CreateResourceRequest,
  { rejectValue: string }
>(
  'resources/create',
  async (requestData, { rejectWithValue }) => {
    try {
      const response = await fetch(`${API_BASE_URL}Resource/CreateResource`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestData),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data: CreateResourceResponse = await response.json();
      
      if (!data.success) {
        return rejectWithValue(data.message || 'Failed to create resource');
      }

      return data;
    } catch (error) {
      return rejectWithValue(error instanceof Error ? error.message : 'Unknown error occurred');
    }
  }
);

export const updateResource = createAsyncThunk<
  UpdateResourceResponse,
  UpdateResourceRequest,
  { rejectValue: string }
>(
  'resources/update',
  async (requestData, { rejectWithValue }) => {
    try {
      const response = await fetch(`${API_BASE_URL}Resource/UpdateResource`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestData),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data: UpdateResourceResponse = await response.json();
      
      if (!data.success) {
        return rejectWithValue(data.message || 'Failed to update resource');
      }

      return data;
    } catch (error) {
      return rejectWithValue(error instanceof Error ? error.message : 'Unknown error occurred');
    }
  }
);

export const deleteResource = createAsyncThunk<
  DeleteResourceResponse,
  DeleteResourceRequest,
  { rejectValue: string }
>(
  'resources/delete',
  async (requestData, { rejectWithValue }) => {
    try {
      const response = await fetch(`${API_BASE_URL}Resource/DeleteResource`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestData),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data: DeleteResourceResponse = await response.json();
      
      if (!data.success) {
        return rejectWithValue(data.message || 'Failed to delete resource');
      }

      return data;
    } catch (error) {
      return rejectWithValue(error instanceof Error ? error.message : 'Unknown error occurred');
    }
  }
);